module.exports = __webpack_public_path__ + "static/media/desktop.63671198.svg";